import URL from '../url'
import Request from '../request'

/**
 * Get primary interests list
 */
export const getPrimaryInterestsService = () =>
  new Request(URL.API, URL.GET_PRIMARY_INTERESTS).get()
